import { makeStyles } from "@material-ui/core/styles";

/**
 * The app's content measure — a hard ceiling on how wide a page's grid may grow.
 *
 * Backstage's `<Content>` fills whatever the viewport gives it, so with a handful of tiles per page
 * the grid tracks keep growing and cards letterbox on a full-screen monitor.
 *
 * One number shared by every page rather than a per-page constant, so pages line up when you
 * navigate between them. 1080px holds three tile columns at the `spacing={3}` the MUI pages use.
 */
export const CONTENT_MAX_WIDTH = 1080;

/** Centres a page's `<Grid container>` at {@link CONTENT_MAX_WIDTH}. */
export const useContentWidthStyles = makeStyles({
	grid: {
		maxWidth: CONTENT_MAX_WIDTH,
		margin: "0 auto",
	},
});
